import { useContext, useEffect } from "react";
import { createPortal } from "react-dom";
import { AppContext } from "../contexts/AppContext";
import ForgetPassword from "./ForgetPassword";
import ForgetResetOtp from "./ForgetConfirmOtp";
import ResetPassword from "./ResetPassword";
import RegisterConfirmOtp from "./RegisterConfirmOtp";
import SuccessModal from "./SuccessModal";
import ResetPasswordSuccess from "./ResetPasswordSuccess";
import PostText from "./PostText";
import PostDocument from "./PostDocument";
import PostVideo from "./PostVideo";
import PostPhoto from "./PostPhoto";
import AddBackground from "./AddBackground";
import AddProfilePhoto from "./AddProfilePhoto";
import AddBasicInfo from "./AddBasicInfo";
import AddAbout from "./AddAbout";
import AddEducation from "./AddEducation";
import AddExperience from "./AddExperience";
import AddSkills from "./AddSkills";
import AddInterest from "./AddInterest";
import AddExpertise from "./AddExpertise";
import AddHeadline from "./AddHeadline";
import AddEditService from "../views/AddEditService";
import JoinSession from "../components/JoinSession";
import CancelSession from "../components/CancelSession";
import RescheduleSession from "../components/RescheduleSession";
import Feedback from "../components/Feedback";
import QueryReply from "../components/QueryReply";
import BlockDatesCalendar from "../components/Calendar/BlockDatesCalendar";
import AddReels from "./AddReel";
import ReportPost from "../components/ReportPost";
import RescheduleWeeklySession from "../components/RescheduleWeeklySession";
import AddBankAccount from "./AddBankAccount";
import ChangePassword from "../components/ChangePassword";
import DeleteAccount from "../components/DeleteAccount";
import MentorFeedback from "../components/MentorFeedback";
import ShowMoreModal from "../components/ShowMoreModal";
import BlockUser from "../components/BlockUser";
import Filter from "../components/Filter";
import { useLocation } from "react-router-dom";
import SubscriptionPayment from "../components/SubscriptionPayment";
import SubscriptionAlert from "../components/SubscriptionAlert";
import PublicSettings from "../components/PublicSettings";
import BookingSuccess from "../components/BookingSuccess";
import ConfirmationAlert from "../components/ConfirmationAlert";
import AddEditProduct from "../components/AddEditProduct";
import DeleteItem from "../views/DeleteItem";

const ModalBody = () => {
  const { openModal, updateModalState, openedModal } = useContext(AppContext);
  const { openedModal: type, title, data = null } = openedModal || {};
  const location = useLocation();

  useEffect(() => {
    if (openModal) {
      updateModalState();
    }
  }, [location.pathname]);

  return (
    <div
      className={`modal ${
        type === "rescheduleSession" && "scroll-modal"
      } modal-bg fade ${openModal ? "show" : ""}`}
      id="logoutModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            {title && (
              <h5 className="modal-title" id="exampleModalLongTitle">
                {title}
              </h5>
            )}
            {type !== "bookingSuccess" && (
              <button
                onClick={updateModalState}
                className="close"
                type="button"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            )}
          </div>
          {type && type === "forgetPassword" && <ForgetPassword />}
          {type && type === "forgetOTP" && <ForgetResetOtp />}
          {type && type === "resetPassword" && <ResetPassword />}
          {type && type === "registerConfirm" && (
            <RegisterConfirmOtp data={data} />
          )}
          {type && type === "successModal" && <SuccessModal />}
          {type && type === "resetSuccess" && <ResetPasswordSuccess />}
          {type && type === "postText" && <PostText data={data} />}
          {type && type === "postDocument" && <PostDocument data={data} />}
          {type && type === "postVideo" && <PostVideo data={data} />}
          {type && type === "postPhoto" && <PostPhoto data={data} />}
          {type && type === "addBackgroundImage" && <AddBackground />}
          {type && type === "addProfilePhoto" && <AddProfilePhoto />}
          {type && type === "addBasicInfo" && <AddBasicInfo />}
          {type && type === "addAbout" && <AddAbout />}
          {type && type === "addHeadline" && <AddHeadline />}
          {type && type === "addEducation" && <AddEducation />}
          {type && type === "addExperience" && <AddExperience />}
          {type && type === "addSkills" && <AddSkills />}
          {type && type === "addInterest" && <AddInterest />}
          {type && type === "addExpertise" && <AddExpertise />}
          {type && type === "addEditService" && (
            <AddEditService
              editData={data}
              isEdit={title === "Edit Service" && true}
            />
          )}
          {type && type === "addEditProduct" && (
            <AddEditProduct
              editData={data}
              isEdit={title === "Edit Product" && true}
            />
          )}
          {type && type === "deleteItem" && <DeleteItem data={data} />}
          {type && type === "joinSession" && <JoinSession data={data} />}
          {type && type === "rescheduleSession" && (
            <RescheduleSession data={data} />
          )}
          {type && type === "cancelSession" && <CancelSession data={data} />}
          {type && type === "block" && <BlockUser data={data} />}
          {type && type === "rescheduleWeeklySession" && (
            <RescheduleWeeklySession data={data} />
          )}
          {type && type === "subscription" && (
            <SubscriptionPayment data={data} />
          )}
          {type && type === "subscriptionAlert" && (
            <SubscriptionAlert data={data} />
          )}
          {type && type === "filter" && <Filter />}
          {type && type === "feedback" && <Feedback data={data} />}
          {type && type === "mentorFeedback" && <MentorFeedback data={data} />}
          {type && type === "replyQuery" && <QueryReply data={data} />}
          {type && type === "blockDates" && <BlockDatesCalendar />}
          {type && type === "addReels" && <AddReels data={data} />}
          {type && type === "reportPost" && <ReportPost data={data} />}
          {type && type === "bankAcc" && <AddBankAccount data={data} />}
          {type && type === "changePassword" && <ChangePassword />}
          {type && type === "deleteAccount" && <DeleteAccount />}
          {type && type === "addExtraInfo" && <ShowMoreModal data={data} />}
          {type && type === "public" && <PublicSettings data={data} />}
          {type && type === "bookingSuccess" && <BookingSuccess data={data} />}
          {type && type === "confirmationAlert" && (
            <ConfirmationAlert data={data} />
          )}
        </div>
      </div>
    </div>
  );
};
const Modal = (props) => {
  return createPortal(<ModalBody />, document.getElementById("modal-root"));
};

export default Modal;
